module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1600.ef1c8b01.svg";